import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import instance from "../../../config/Config";

const initialState = {
  loading: false,
  response: null,
  globalPaymentList: null,
  error: null,
  invoice: [],
  count: null,
  totalSale: 0,
  totalThisMonthSale: 0,
  totalLastMonthSale: 0,
  todaySale: 0,
  thisYearSale: 0,
  lastYearSale: 0,
  UpdateId: null,
  paymentList: null,
  subscriptionStart: null,
  subscriptionLoading: false,
  customerList: null,
  customerDetails: null,
  searchLoading: null,
  customerLoading: null,
  linkLoading: false
};

// PAYMENT LINKJ GENERATE-
export const GeneratePaymentLink = createAsyncThunk(
  "GeneratePaymentLink",
  async (data, { rejectWithValue }) => {
    try {
      const response = instance.post("crm/payment/payment-link-gen", data);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
// GLOBAL PAYMENT LINK GENERATE-
export const GenerateGlobalPaymentLink = createAsyncThunk(
  "GenerateGlobalPaymentLink",
  async (data, { rejectWithValue }) => {
    try {
      const response = instance.post("crm/payment/payment-global-link", data);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

//GET PAYMENT LIST
export const getPaymentList = createAsyncThunk(
  "getPaymentList",
  async (body, { rejectWithValue }) => {
    try {

      const response = instance.get(
        `crm/payment/payment-list?page=${body?.page}&search=${body?.search}`
      );

      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
//GET GLOBAL PAYMENT LIST
export const getGlobalPaymentList = createAsyncThunk(
  "getGlobalPaymentList",
  async (body, { rejectWithValue }) => {
    try {
      const response = instance.get(`crm/payment/global-payment-list?page=${body?.page}&search=${body?.search}&startDate=${body.startDate}&endDate=${body.endDate}&status=${body.status}`);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

//GET SINGLE PAYMENT DETAIL
export const getSinglePaymentDetail = createAsyncThunk(
  "getSinglePaymentDetail",
  async (body, { rejectWithValue }) => {
    try {
      const response = instance.get(
        `crm/payment/single-payment-detail?pay_id=${body.pay_id}`
      );

      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
//UPLOAD INVOICE DETAIL
export const uploadPaymentInvoice = createAsyncThunk(
  "uploadPaymentInvoice",
  async (body, { rejectWithValue }) => {
    try {

      const response = instance.post(
        `crm/payment/upload-payment-invoice`, body
      );


      //       const response = instance.get(`crm/payment/payment-link-list?page=${body?.page}&search=${body?.search}`);
      // >>>>>>> 2a242eac04cae6d420c354c87147d1791f7a6252

      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const PaymentInvoiceUpload = createAsyncThunk(
  "PaymentInvoiceUpload",
  async (body) => {
    try {
      const formData = new FormData();
      formData.append("userId", body.buy_sub_user_id);
      formData.append("invoice_pdf", body.invoice_pdf[0]);
      const res = await axios.post("https://testapi.remarkhr.com/employers/add-invoice", formData);
      return res?.data;
    } catch (error) {
      throw error;
    }
  }
);

// {Update Payemnt Id}
export const UpdatePaymentId = createAsyncThunk(
  "UpdatePaymentId",
  async (data) => {
    try {

      const response = await instance.post(
        `crm/payment/update-order-payment?pay_id=${data.pay_id}`,
        {
          payment_razorpay_id: data?.payment_razorpay_id,
          pay_razorpay_order_id: data?.pay_razorpay_order_id,
        }
      );
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

// ======================================================
// GET PACKAGE LIST
// ======================================================

export const getPackageList = createAsyncThunk(
  "payment/getPackageList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await instance.get(
        "remark/package/fetch-all-package"
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || err.message
      );
    }
  }
);

export const startSubscription = createAsyncThunk(
  "startSubscription",
  async (data, { rejectWithValue }) => {

    try {

      const response = await instance.post(
        "crm/payment/subscription-start",
        data
      );

      return response.data;

    } catch (err) {

      return rejectWithValue(
        err.response?.data || err.message
      );

    }

  }
);

export const searchCustomerList = createAsyncThunk(
  "searchCustomerList",

  async (keyword, { rejectWithValue }) => {

    try {

      const response = await instance.get(
        `remark/user/search-user?keyword=${keyword}`
      );

      return response.data;

    } catch (err) {

      return rejectWithValue(
        err.response?.data || err.message
      );

    }

  }
);
export const singleCustomerDetails = createAsyncThunk(
  "singleCustomerDetails",

  async (id, { rejectWithValue }) => {

    try {

      const response = await instance.get(
        `remark/user/get-single-customer-detail?user_id=${id}`
      );

      return response.data;

    } catch (err) {

      return rejectWithValue(
        err.response?.data || err.message
      );

    }

  }
);


export const paymentSlice = createSlice({
  name: "paymentSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPaymentList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPaymentList.fulfilled, (state, action) => {


      state.loading = false;
      state.response = action?.payload?.data;
      state.totalSale = action?.payload?.totalSale;
      state.totalThisMonthSale = action?.payload?.totalThisMonthSale;
      state.totalLastMonthSale = action?.payload?.totalLastMonthSale;
      state.todaySale = action?.payload?.todaySale;
      state.thisYearSale = action?.payload?.thisYearSale;
      state.lastYearSale = action?.payload?.lastYearSale;

    });
    builder.addCase(getPaymentList.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(getGlobalPaymentList.pending, (state) => {
      state.loading = true;

    });
    builder.addCase(getGlobalPaymentList.fulfilled, (state, action) => {
      state.loading = false;
      state.globalPaymentList = action?.payload?.data;
      state.count = action?.payload?.count;
    });

    builder.addCase(getGlobalPaymentList.rejected, (state, action) => {
      state.loading = false;
    });


    builder.addCase(PaymentInvoiceUpload.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(PaymentInvoiceUpload.fulfilled, (state, action) => {

      state.loading = false;
      state.invoice = action?.payload?.data;
    });
    builder.addCase(PaymentInvoiceUpload.rejected, (state, action) => {
      state.loading = false;
    })

    builder.addCase(UpdatePaymentId.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(UpdatePaymentId.fulfilled, (state, action) => {
      state.loading = false;
      state.UpdateId = action.payload;
    });
    builder.addCase(UpdatePaymentId.rejected, (state, action) => {

      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(getPackageList.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(
      getPackageList.fulfilled,
      (state, action) => {
        state.loading = false;

        state.paymentList =
          action.payload?.data || [];

        state.count =
          action.payload?.count || 0;
      }
    );

    builder.addCase(
      getPackageList.rejected,
      (state, action) => {
        state.loading = false;

        state.error = action.payload;
      }
    );


    builder.addCase(startSubscription.pending, (state) => {
      state.subscriptionLoading = true;
    });

    builder.addCase(
      startSubscription.fulfilled,
      (state, action) => {
        state.subscriptionLoading = false;

        state.subscriptionStart =
          action.payload?.subscriptionStart || [];
      }
    );

    builder.addCase(
      startSubscription.rejected,
      (state, action) => {
        state.subscriptionLoading = false;

        state.error = action.payload;
      }
    );

    builder.addCase(searchCustomerList.pending, (state) => {
      state.searchLoading = true;

    });
    builder.addCase(searchCustomerList.fulfilled, (state, action) => {
      state.searchLoading = false;
      state.customerList = action?.payload?.data;
    });

    builder.addCase(searchCustomerList.rejected, (state, action) => {
      state.searchLoading = false;
    });
    builder.addCase(singleCustomerDetails.pending, (state) => {
      state.customerLoading = true;

    });
    builder.addCase(singleCustomerDetails.fulfilled, (state, action) => {
      state.customerLoading = false;
      state.customerDetails = action?.payload?.data;
    });

    builder.addCase(singleCustomerDetails.rejected, (state, action) => {
      state.customerLoading = false;
    });


    builder
      .addCase(GenerateGlobalPaymentLink.pending, (state) => {
        state.linkLoading = true;
      })

      .addCase(GenerateGlobalPaymentLink.fulfilled, (state) => {
        state.linkLoading = false;
      })

      .addCase(GenerateGlobalPaymentLink.rejected, (state) => {
        state.linkLoading = false;
      });


  },
});
export default paymentSlice.reducer;
